export default function PageMeta( { title , length, description } ){
    return(
        <div style = { { width : "100%", textAlign : "center", marginBottom : "40px" } }>
            <h3>{ length } { title }</h3>
            <p>{ description }</p>
      </div>
    )
}